<template>
  <div class="wrappers">
    <div
      v-if="storeInfo && storeInfo.book_img"
      style="
        background: #e23024;
        min-height: 100vh;
        position: relative;
        background-image: url(https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon5.png);
        background-repeat: no-repeat;
        background-position: top;
        background-size: cover;
      "
    >
      <!-- <img src="./images/icon1.png" class="bg-img"> -->
      <img :src="storeInfo.logo" class="logo-img" />
      <img :src="storeInfo.title_img" class="title-img" />
      <div class="title-btn-box" v-if="storeInfo.title_btn_text">
        <img :src="storeInfo.title_btn_img" />
        <div class="title-btn">{{ storeInfo.title_btn_text }}</div>
      </div>
      <div class="time" v-if="storeInfo.time">{{ storeInfo.time }}</div>
      <img :src="storeInfo.book_img" class="book-img" />
      <div class="open-button2">
        <OpenApp :unitKey="schemaUnitKey" :options="config" :appendParam="null">
          <div @click="openApp" class="open-button">打开APP图书商城</div>
        </OpenApp>
      </div>
    </div>
    <div v-else>
      <van-empty description="活动已结束" />
    </div>
  </div>
</template>

<script>
import OpenApp from '@/components/OpenApp.vue'
import { getCurrentBrand } from '@/config/brand'
export default {
  components: {
    OpenApp,
  },
  data() {
    return {
      schemaUnitKey: 'Store',
      config: { unitKey: 'Store', param: null },
      allocation: {
        skb: {
          common: {
            logo: 'https://skbang-1253756937.cos.ap-guangzhou.myqcloud.com/app_guide/chongqing/attachment/2024-3-14/92139367225.png',
            title_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon3.png',
            title_btn_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon4.png',
            title_btn_text: '低至3折起 领券更优惠',
            time: '活动时间：2月4日-2月24日',
            book_img: '',
          },
          sichuan: {
            logo: 'https://skbang-1253756937.cos.ap-guangzhou.myqcloud.com/app_guide/chongqing/attachment/2024-3-14/92139367225.png',
            title_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon3.png',
            title_btn_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon4.png',
            title_btn_text: '',
            time: '',
            book_img:
              'https://skbang-1253756937.cos.ap-guangzhou.myqcloud.com/app_guide/yunnan/attachment/2024-3-14/72954230531.png',
          },
        },
        gpjs: {
          common: {
            logo: 'https://skbang-1253756937.cos.ap-guangzhou.myqcloud.com/app_guide/chongqing/attachment/2024-3-14/00844576299.png',
            title_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon3.png',
            title_btn_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon4.png',
            title_btn_text: '低至3折起 领券更优惠',
            time: '活动时间：2月4日-2月24日',
            book_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon6.png',
          },
          sichuan: {
            logo: 'https://skbang-1253756937.cos.ap-guangzhou.myqcloud.com/app_guide/chongqing/attachment/2024-3-14/00844576299.png',
            title_img:
              'https://skbang-1253756937.cos.ap-guangzhou.myqcloud.com/app_guide/chongqing/attachment/2024-3-14/32617058058.png',
            title_btn_img:
              'https://statics-1253756937.cos.ap-chengdu.myqcloud.com/app/store/download/images/icon4.png',
            title_btn_text: '',
            time: '',
            book_img:
              'https://skbang-1253756937.cos.ap-guangzhou.myqcloud.com/app_guide/yunnan/attachment/2024-3-14/74983614476.png',
          },
        },
      },
      storeInfo: {},
    }
  },
  created() {
    document.title = getCurrentBrand.name + '图书商城'
    // if (!this.$browser.isWXBrowser()) {
    //     this.openApp()
    // }
  },
  mounted() {
    setTimeout(() => {
      this.setShareCard()
    }, 1000)
    let key = this.getCurrentBrand.brandKey
    let province = this.$route.query.province
    this.storeInfo = province ? this.allocation[key][province] : this.allocation[key][common]
  },
  methods: {
    // 唤醒APP
    openAPPSchema(schema) {
      let protocal = this.$brandConfig.getCurrentBrandSchemaParam.protocal
      let failUrl = this.$brandConfig.getCurrentBrandSchemaParam.failUrl
      this.$openSchema({
        protocal: protocal,
        schema: 'openUnit/schema?params=' + JSON.stringify(schema),
        failUrl: `https://a.app.qq.com/o/simple.jsp?pkgname=${failUrl}`,
      })
    },

    // 执行打开app方法
    openApp() {
      let unitKey = this.schemaUnitKey
      let province = {
        province: this.$route.query.province,
      }
      const param = this.$route.query.province ? province : null
      const config = {
        type: 'openUnit',
        option: {
          unitKey,
          param,
        },
      }
      this.openAPPSchema(config)
    },
    // 设置分享卡片
    setShareCard() {
      console.log(getCurrentBrand)
      this.$util.setShare({
        title: getCurrentBrand.name + '图书商城' || '',
        desc: '金标尺图书商城，好书随心选！',
        link: window.location.href,
        imgUrl: '',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$mainColor: var(--main-color);

.bg-img {
  position: absolute;
  z-index: -1;
  width: 100%;
  max-width: 750px;
}

html {
  max-width: 500px;
  margin: 0 auto;
}

.logo-img {
  // width: 4.51rem;
  height: 0.64rem;
  display: block;
  margin: 0 auto;
  padding-top: 0.6rem;
}

.title-img {
  width: 6.93rem;
  margin: 0 auto;
  display: block;
}

.title-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  margin-top: 0.35rem;

  img {
    width: 6rem;
    margin: 0 auto;
  }
}

.title-btn {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  top: 50%;
  font-size: 0.48rem;
  color: #ea0302;
  padding: 0 0.64rem;
  // background: linear-gradient(180deg, #FFB472 0%, #D70B0B 100%);
  border-radius: 0.48rem;
  height: 0.96rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

body {
  background: #fff;
  max-width: 500px;
  margin: 0 auto;
}

.wrappers {
  background: #ff362b;
  padding-bottom: 3.2rem;
}

.time {
  font-size: 0.37rem;
  color: #181818;
  margin-top: 0.32rem;
  text-align: center;
}

.open-button {
  width: 7.59rem;
  height: 1.33rem;
  background: linear-gradient(180deg, #ffeba7 0%, #ffba00 100%);
  color: #e95138;
  border-radius: 0.67rem;
  font-size: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.open-button2 {
  position: fixed;
  bottom: 1rem;
  width: 7.59rem;
  left: 50%;
  transform: translateX(-50%);
  height: 1.33rem;
}

.book-img {
  width: 8.93rem;
  margin: 0 auto;
  display: block;
  margin-top: 0.53rem;
  border-radius: 0.4rem;
}
</style>
